import React from 'react';
import { Link } from "react-router-dom";
import { uriEncode } from '../../../../market-share/helpers/helpers';
import PropTypes from 'prop-types';

export const AddressLink = (props) => {

    const { data, pathname, value } = props;
    const { mlsNum, address, areaId, listingTypeId } = data;

    const addressParam = uriEncode(address);
    const search = new URLSearchParams({
        mlsNum,
        address: addressParam,
        id: areaId,
    }).toString();
    const state = { id: areaId, office: addressParam, listingTypeId };

    return <Link to={{ pathname, search, state }}>{ value }</Link>;
};

AddressLink.propTypes = {
    data: PropTypes.object.isRequired,
    pathname: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};
